(() => {
  const descriptionSelector = '[data-collection-description]';
  const buttonSelector = '[data-collection-readmore]';

  const getDescription = (button) => {
    const masthead = button.closest('.productgrid--masthead');
    return masthead
      ? masthead.querySelector(descriptionSelector)
      : document.querySelector(descriptionSelector);
  };

  const syncButton = (button) => {
    const description = getDescription(button);

    if (!description) {
      button.hidden = true;
      return;
    }

    const expanded = description.classList.contains('is-expanded');
    const truncated = description.scrollHeight > description.clientHeight + 2;

    button.dataset.readmoreReady = 'true';
    button.hidden = !expanded && !truncated;
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.textContent = expanded ? 'Read Less' : 'Read More';
  };

  const initialize = () => {
    document.querySelectorAll(buttonSelector).forEach(syncButton);
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    const button = target && target.closest ? target.closest(buttonSelector) : null;

    if (!button) return;

    const description = getDescription(button);
    if (!description) return;

    const expanded = description.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.textContent = expanded ? 'Read Less' : 'Read More';
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  window.addEventListener('load', initialize);
  document.addEventListener('shopify:section:load', initialize);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initialize, 150);
  });
})();
